import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useFetch } from "@/lib/useFetch";
import { useAuth } from "@/context/AuthContext";
import { useTimer } from "@/context/TimerContext";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { PageHeader, StatusBadge, PriorityBadge } from "@/mockups/ui";
import { toast } from "sonner";
import { Play, CheckSquare } from "lucide-react";

export default function Tareas() {
  const { user, can } = useAuth();
  const { start } = useTimer();
  const { data: tasks, loading, refetch } = useFetch("/tasks", { assignee_id: user.user_id });

  const toggle = async (t) => {
    if (!can("tasks", "edit")) return;
    try { await api.patch(`/tasks/${t.id}`, { status: t.status === "done" ? "pending" : "done" }); refetch(); }
    catch (e) { toast.error("Error"); }
  };
  const startTimer = async (t) => {
    if (!can("timesheets", "create")) { toast.error("Sin permiso para registrar horas"); return; }
    try { await start({ project_id: t.project_id, task_id: t.id, milestone_id: t.milestone_id, description: t.title }); }
    catch (e) { toast.error("Error"); }
  };

  return (
    <div className="space-y-6 animate-fade-in-up">
      <PageHeader title="Mis tareas" subtitle="Todo lo que tienes asignado, en un solo lugar" />

      {loading ? <div className="py-16 flex justify-center"><div className="h-7 w-7 rounded-full border-2 border-primary border-t-transparent animate-spin" /></div>
        : (tasks || []).length === 0 ? <Card className="border-border shadow-none py-16 text-center text-sm text-muted-foreground"><CheckSquare className="h-8 w-8 mx-auto mb-3 text-muted-foreground/40" />No tienes tareas asignadas.</Card>
        : (
        <Card className="border-border shadow-none divide-y divide-border overflow-hidden">
          {tasks.map((t) => (
            <div key={t.id} className="group flex items-center gap-3 sm:gap-4 px-4 sm:px-5 py-3.5 hover:bg-muted/40 transition-colors duration-200" data-testid={`task-item-${t.id}`}>
              <Checkbox checked={t.status === "done"} onCheckedChange={() => toggle(t)} className="shrink-0" data-testid={`task-check-${t.id}`} />
              <div className="flex-1 min-w-0">
                <div className={`text-sm font-medium truncate ${t.status === "done" ? "line-through text-muted-foreground" : ""}`}>{t.title}</div>
                <Link to={`/proyecto/${t.project_id}`} className="text-xs text-muted-foreground hover:text-primary transition-colors duration-200">{t.project_name}</Link>
              </div>
              <PriorityBadge priority={t.priority} />
              {t.due_date && <span className="hidden sm:inline text-xs text-muted-foreground tabular-nums w-16 text-right">{new Date(t.due_date).toLocaleDateString("es-ES", { day: "2-digit", month: "short" })}</span>}
              <StatusBadge status={t.status} />
              {can("timesheets", "create") && <Button variant="ghost" size="icon" className="h-8 w-8 text-timer opacity-0 group-hover:opacity-100 transition-opacity duration-200" onClick={() => startTimer(t)} data-testid={`task-timer-${t.id}`}><Play className="h-4 w-4" /></Button>}
            </div>
          ))}
        </Card>
      )}
    </div>
  );
}
